var _path, _path2, _path3, _circle, _text, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10 L20 70 L60 70",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10 L60 10",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40 L50 40",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 70,
    r: 4,
    fill: "#000000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 70,
    fontFamily: "Arial",
    fontSize: 45,
    fontWeight: "bold",
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000"
  }, "Pro"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF"
  }, "gram"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 15 L95 25 L85 35",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270 15 L260 25 L270 35",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogoWhite);
export default __webpack_public_path__ + "static/media/footer__logo_white.e3355c689fb2d1111c12a69279b38b8b.svg";
export { ForwardRef as ReactComponent };